module.exports = __webpack_public_path__ + "img/12-1.3c00a439.png";